export type File = {
  readonly fileName: string,
  readonly mimeType: string,
  readonly data: string,
};

export const dispatchFileEvent = (eventName: string, file: File) => {
  window.dispatchEvent(new CustomEvent(eventName, {
    detail: {
      data: file.data,
      mimeType: file.mimeType,
      fileName: file.fileName,
    },
  }));
};
